import { Row, Col, Card, Input, Form, Divider } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { dodSecurityConfig } from './formConfig';
import { FaqModal } from '@bit/ui-common.ui-components/ss-common-data';

const
config = dodSecurityConfig,
{ key } = config,
{ generateFormItem, generateInputComponent } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class DodSecurity extends React.Component {
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    render() {
        const
        { services, registrationForm } = this.props,
        { storeFormField, storeForm, toggleHelpFaqModal } = services,
        form = registrationForm[key];
        return (
            <div>
                <FaqModal />
                <Row type='flex' justify='center' style={{ marginBottom: '20px' }}>
                    <Col span={20}>
                        <Card
                            hoverable
                            bodyStyle={{ padding: '15px 20px 15px 20px' }}
                            style={{ cursor: 'default' }}
                        >
                            <div style={{ textAlign: 'left', marginBottom: '15px' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    {'Attention: '}
                                </span>
                                <br />
                                <span style={{ fontStyle: 'italic' }}>
                                    {'You must now provide your own personalized answers to the security questions below.'}
                                </span>
                            </div>
                            <div style={{ textAlign: 'left' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    {'Instructions: '}
                                </span>
                                <br />
                                <span style={{ fontStyle: 'italic' }}>
                                    {'Please answer the 3 security questions below and type your responses in the boxes provided.'}
                                </span>
                            </div>
                            <Divider type='horizontal' />
                            <div style={{ textAlign: 'left', fontSize: '12px', lineHeight: '17px' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    {'Tip: '}
                                </span>
                                <span style={{ fontStyle: 'italic' }}>
                                    {' Choose answers that you can easily remember. FTSP will not be able to supply these '}
                                    {'answers if you forget them. If you forget your login information and no longer have '}
                                    {'access to the email address on file, you can now change your email address online '}
                                    {'after correctly answering the security questions. For more information about the Online Portal '}
                                    {'Security Questions, please visit the '}
                                    <a href="/home/help?view=d&tab=faqs" target="_blank">
                                        {'Frequently Asked Questions (FAQ) '}
                                    </a>
                                    {'page.'}
                                </span>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='center'>
                    <Col span={23}>
                        <Row gutter={12} type='flex' justify='center'>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('born', config, form)} style={{overflow:'hidden'}}>
                                    <Input {...{...generateInputComponent('born', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('food', config, form)} style={{overflow:'hidden'}}>
                                    <Input {...{...generateInputComponent('food', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item {...generateFormItem('color', config, form)} style={{overflow:'hidden'}}>
                                    <Input {...{...generateInputComponent('color', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
